import { createContext, useContext } from "react";

export type ChromeContextValue = {
  readonly openCheat: () => void;
  readonly openPalette: () => void;
};

export const ChromeContext = createContext<ChromeContextValue | null>(null);

export const useChrome = (): ChromeContextValue => {
  const value = useContext(ChromeContext);
  if (!value) {
    throw new Error("useChrome must be used within a Layout");
  }
  return value;
};
